import React from "react";
import "./Terms.css";
import TermsHeader from "./TermsHeader";

const Terms = () => {
  const termsData = [
    {
      title: "Acceptance of Terms",
      description:
        "By using Srimathi Manpower Consultancy's services, you agree to abide by the terms and conditions outlined herein.",
    },
    {
      title: "Eligibility",
      description:
        "Our services are intended for employers seeking employees and job seekers looking for employment opportunities.",
    },
    {
      title: "Service Description",
      description:
        "We provide recruitment solutions, including job posting, candidate screening, and placement services.",
    },
    {
      title: "User Obligations",
      description:
        "Users must provide accurate and up-to-date information. Misrepresentation may lead to suspension or termination of services.",
    },
    {
      title: "Confidentiality",
      description:
        "We maintain strict confidentiality of user information and only share details with relevant employers or job seekers.",
    },
    {
      title: "Payment Terms",
      description:
        "Employers are required to pay service fees as per the agreement. No fees are charged to job seekers.",
    },
    {
      title: "Limitation of Liability",
      description:
        "Srimathi Manpower Consultancy is not liable for any employment disputes or issues arising between employers and employees.",
    },
    {
      title: "Termination and Suspension",
      description:
        "We reserve the right to suspend or terminate user accounts for violation of terms or misuse of our services.",
    },
    {
      title: "Amendments to Terms",
      description:
        "We may update the terms and conditions periodically. Continued use implies acceptance of the revised terms.",
    },
    {
      title: "Governing Law",
      description:
        "These terms are governed by the laws of India, and any disputes are subject to the jurisdiction of Indian courts.",
    },
  ];

  return (
    <>
      <TermsHeader />
      <div className="terms-container container">
        <h1 className="terms-title">Terms and Conditions</h1>
        {termsData.map((item, index) => (
          <div key={index} className="terms-section">
            <h2 className="terms-subtitle">{item.title}</h2>
            <p className="terms-description">{item.description}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default Terms;
